import { useCallback } from 'react';
import { NavMarker } from 'react-rhumb';
import http from 'hub-http/clients/apiClient';
import { ContentObjectTypes, useContentObjectType } from 'content-management-data-lib';
import ReportingFilters from 'content-management-details-lib/components/reporting/ReportingFilters';
import useTestResultsData from '../../hooks/useTestResultsData';
import { displayActionErrorMessage, displayActionSuccessMessage } from '../../utils/actions';
import ABVariationsTable from './ABVariationsTable';
import ABVariationsChart from './ABVariationsChart';
import { useTrackPageView } from '../../hooks/useTrackPageView';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const requestChooseABWinner = ({
  pageId,
  isLandingPage,
  abTestId
}) => {
  return http.post(`cospages/v2/${isLandingPage ? 'landing' : 'site'}-pages/end-ab-test/${abTestId}`, {
    data: pageId
  });
};
const requestRerunVariation = ({
  pageId,
  isLandingPage,
  abTestId
}) => {
  const data = {
    abTestId,
    newState: 'PUBLISHED_AB_VARIANT',
    rerunId: pageId
  };
  return http.post(`cospages/v2/${isLandingPage ? 'landing' : 'site'}-pages/rerun-ab-test`, {
    data
  });
};
const ABVariations = ({
  abVariants
}) => {
  const abVariationsIds = abVariants.map(({
    id
  }) => `${id}`);
  const {
    contentObjectType
  } = useContentObjectType();
  const {
    abTestId,
    refetchAbVariants
  } = useTestResultsData();
  const handleChooseABWinner = useCallback(pageId => {
    const isLandingPage = contentObjectType === ContentObjectTypes.LANDING_PAGE;
    requestChooseABWinner({
      abTestId: abTestId,
      isLandingPage,
      pageId
    }).then(() => {
      displayActionSuccessMessage({
        isLandingPage,
        actionId: 'chooseWinner'
      });
      refetchAbVariants({
        abTestId: abTestId,
        isLandingPage
      }).catch(error => {
        throw error;
      });
    }).catch(() => {
      displayActionErrorMessage({
        isLandingPage,
        actionId: 'chooseWinner'
      });
    });
  }, [abTestId, contentObjectType, refetchAbVariants]);
  const handleRerunVariation = useCallback(pageId => {
    const isLandingPage = contentObjectType === ContentObjectTypes.LANDING_PAGE;
    requestRerunVariation({
      abTestId: abTestId,
      isLandingPage,
      pageId
    }).then(() => {
      displayActionSuccessMessage({
        isLandingPage,
        actionId: 'rerunVariation'
      });
      refetchAbVariants({
        abTestId: abTestId,
        isLandingPage
      }).catch(error => {
        throw error;
      });
    }).catch(() => {
      displayActionErrorMessage({
        isLandingPage,
        actionId: 'rerunVariation'
      });
    });
  }, [abTestId, contentObjectType, refetchAbVariants]);
  useTrackPageView('variations');
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "VARIATIONS_LOADED",
    children: [/*#__PURE__*/_jsx(ReportingFilters, {}), /*#__PURE__*/_jsx(ABVariationsChart, {
      abVariationsIds: abVariationsIds
    }), /*#__PURE__*/_jsx(ABVariationsTable, {
      abVariationsIds: abVariationsIds,
      abVariantsList: abVariants,
      handleChooseABWinner: handleChooseABWinner,
      handleRerunVariation: handleRerunVariation
    })]
  });
};
export default ABVariations;